import {tableStyling} from "./ConnectedTagsDialog/Table/tableStyling";
import {datagridCustomColumn, DynamicDatagrid, IDataGridProps, MuiDataGrid, Typography, Paper} from "@leap4/frontend";
import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import * as React from "react";
import {ScrapingUtils} from "../../../../../utils/scraping.utils";
import PercentCell from "../../../../shared/PercentCell/PercentCell";
type GridRowModel = MuiDataGrid.GridRowModel;

const align = 'left'

export interface ISupplyTag {
    id: string,
    name: string,
    campaignId: string
}

export interface IMetricsTotals{
    revenue: number,
    impressions: number
}

export interface ITopDiscrepancyTagsResult{
    supplyTag: ISupplyTag,
    adServerTotals: IMetricsTotals,
    publisherTotals: IMetricsTotals,
    discrepancy: IMetricsTotals
}
function createRowData(item:ITopDiscrepancyTagsResult): GridRowModel {
    return {
        id: item.supplyTag.id,
        supplyTagName: item.supplyTag.name,
        campaignId: item.supplyTag.campaignId,
        adServerRevenue: item.adServerTotals.revenue,
        publisherRevenue: item.publisherTotals.revenue,
        discrepancyRevenue: item?.discrepancy.revenue,
        adServerImpressions: item.adServerTotals.impressions,
        publisherImpressions: item.publisherTotals.impressions,
        discrepancyImpressions: item?.discrepancy.impressions
    }
}

export interface ITopDiscrepancyTagsTableProps extends Partial<IDataGridProps> {
    items: Array<ITopDiscrepancyTagsResult>,
    loading: boolean,
}

export default function TopDiscrepancyTagsTable({items, loading, refreshFunc}: ITopDiscrepancyTagsTableProps){
    const columns: datagridCustomColumn[] = [
        {
            field: 'supplyTagName',
            headerName: 'Supply Tag Name',
            width: 500,
            renderCell: (params => {
                return <Link to={`${urlService.adServerTag(params.id.toString(), true)}`}>
                    <Typography   style={{fontWeight:"bolder"}}> {params.value}</Typography>
                </Link>
            })
        },
        {
            field: 'campaignId',
            headerName: 'Campaign ID',
            width: 150,
        },
        {
            field: 'adServerRevenue',
            headerName: 'Ad Server Revenue',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
            }
        },
        {
            field: 'publisherRevenue',
            headerName: 'Publisher Revenue',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
            }
        },
        {
            field: 'discrepancyRevenue',
            headerName: '',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value ? <PercentCell percent={params.value as number}/> : ""
            }
        },
        {
            field: 'adServerImpressions',
            headerName: 'Ad Server Impressions',
            type: 'number',
            width: 180,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
            }
        },
        {
            field: 'publisherImpressions',
            headerName: 'Publisher Impressions',
            type: 'number',
            width: 180,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
            }
        },
        {
            field: 'discrepancyImpressions',
            headerName: '',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value ? <PercentCell percent={params.value as number}/> : ""
            }
        }
    ]

    const rows = items.map((row) =>
        createRowData(row)
    ).sort((a,b) => b.revenue > a.revenue ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", ...tableStyling.paperTable}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={loading}
                             loadError={false}
                             pageSize={100}
                             refreshFunc={refreshFunc}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    );
}